import {
  Box,
  chakra,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useBoolean,
} from "@chakra-ui/react";
import { ReactNode } from "react";
import BusinessButton, { BtnProps } from "./BusinessButton";

export interface BannerCardProps {
  src: string;
  tagText: string;
  title: string | ReactNode;
  content: string | ReactNode;
  btnProps: BtnProps;
  reverse?: boolean;
}

function BannerCard(props: BannerCardProps) {
  const [imageView, imageViewOp] = useBoolean(false);
  const { tagText, title, content, btnProps, src, reverse = false, ...styles } = props;
  return (
    <Flex
      w="1200px"
      h="405px"
      mx="auto"
      justify="space-between"
      flexDir={reverse ? "row-reverse" : "row"}
      {...styles}
    >
      <Flex align="center" h="100%" w="400px">
        <Box w="400px" flexShrink={0}>
          <BusinessButton
            text={tagText}
            onClick={() => null}
            theme="blueTag"
            mb="10px"
            cursor="default"
          />
          <Text fontSize="28px" fontWeight={600}>
            {title}
          </Text>
          {content}
          <BusinessButton mt="32px" display="block" {...btnProps} />
        </Box>
      </Flex>
      <Box h="100%" w="720px" cursor="zoom-in" onClick={imageViewOp.on}>
        <Image src={src} objectFit="cover" />
      </Box>
      <Modal isOpen={imageView} onClose={imageViewOp.off} isCentered>
        <ModalOverlay />
        <ModalContent maxW="80vw" w="fit-content">
          <ModalCloseButton />
          <ModalBody>
            <Image src={src} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

export default chakra(BannerCard);
